<template>
  <div>
    <AppSpinner v-if="loadingSpinner" :loading="loadingSpinner" />

    <div style="padding: 10px; overflow-x: auto;">
      <transition mode="out-in" name="fade">
        <div class="installation-table" v-if="!loadingSpinner">
          <div class="sticky_header">
            <div class="singleInstallationRow__btns md-layout md-raised">
              <div
                class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 md-small-size-20 singleInstallationRow__check-btn check-btn main-checkbox"
              >
                <input
                  type="checkbox"
                  class="input-check-box"
                  v-model="isAllChecked"
                />
                <md-icon>arrow_drop_down</md-icon>
              </div>
              <div class="md-layout-item">
                <md-button
                  @click="updateMarkedAsInstalled()"
                  class="mark-installed-btn"
                  >Mark installed
                  <md-icon class="main-icons icons mark-installed-icon"
                    >layers</md-icon
                  ></md-button
                >
                <md-button
                  @click="updateMarkedAsRemoved()"
                  class="mark-removed-btn"
                  >Mark removed
                  <md-icon class="main-icons icons mark-removed-icon"
                    >layers_clear</md-icon
                  ></md-button
                >
                <md-button
                  @click="updateMarkedAsArrivedInStaging()"
                  class="md-ripple mark-arrived-btn"
                  >Mark Arrived In Staging <md-icon class="main-icons icons mark-arrived-icon">local_shipping</md-icon></md-button
                >
              </div>
              <div class="md-layout-item">
                <md-button
                  @click="updateMarkedAsGivenToAndMore()"
                  class="md-ripple mark-given-to-andmore-btn"
                  >Given to AndMore
                  </md-button
                >
                <md-button
                  @click="updateMarkedAsDeliveredToSpecificLocation()"
                  class="md-ripple mark-delivered-to-location-btn"
                  >Delivered to Specific Location
                  </md-button
                >
              </div>
            </div>

            <div class="singleInstallationRow__header md-layout md-raised">
              <div
                class="md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-10 md-small-size-10"
              ></div>
              <div
                class="md-layout-item md-xlarge-size-90 md-large-size-90 md-medium-size-90 md-small-size-90"
              >
                <div class="md-layout">
                  <h2
                    class="md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-10 md-small-size-15"
                    @click="orderResults('id')"
                  >
                    <md-tooltip md-direction="top">Click to sort</md-tooltip>
                    Order ID
                  </h2>
                  <h2
                    class="md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-20 md-small-size-30"
                    @click="orderResults('spaceDescription')"
                  >
                    <md-tooltip md-direction="top">Click to sort</md-tooltip>
                    AD CODE
                  </h2>
                  <h2
                    class="md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-10 md-small-size-30"
                    @click="orderResults('materialName')"
                  >
                    <md-tooltip md-direction="top">Click to sort</md-tooltip>
                    MATERIAL
                  </h2>
                  <h2
                    class="md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25"
                    @click="orderResults('statusName')"
                  >
                    <md-tooltip md-direction="top">Click to sort</md-tooltip>
                    STATUS
                  </h2>
                  <h2
                    class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 mobile-remove"
                    @click="orderResults('size')"
                  >
                    <md-tooltip md-direction="top">Click to sort</md-tooltip>
                    SIZE
                  </h2>
                  <h2
                    class="md-layout-item md-xlarge-size-25 md-large-size-20 md-medium-size-20 mobile-remove"
                    @click="orderResults('deposition')"
                  >
                    <md-tooltip md-direction="top">Click to sort</md-tooltip>
                    DISPOSITION
                  </h2>
                  <h2
                    class="md-layout-item md-large-size-5 md-medium-size-5 mobile-remove"
                  ></h2>
                </div>
              </div>
            </div>
          </div>

          <div
            v-for="(installation, index) in sortedInstallations"
            :key="index + '_singleClass'"
          >
            <div
              class="singleInstallationRow md-raised md-layout"
              :class="{ expanded: installation.is_expanded }"
            >
              <div
                class="md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-10 md-small-size-10"
              >
                <div class="md-layout md-layout-item">
                  <div class="singleInstallationRow__check-btn check-btn">
                    <label>
                      <input
                        type="checkbox"
                        class="input-check-box"
                        v-model="installation.is_checked"
                      />
                    </label>
                  </div>
                </div>
              </div>

              <div
                class="md-layout-item md-xlarge-size-90 md-large-size-90 md-medium-size-90 md-small-size-90"
              >
                <div class="md-raised md-layout">
                  <div
                    class="singleInstallationRow__data blue-color special-labels md-xlarge-size-10 md-layout-item md-large-size-10 md-medium-size-10 md-small-size-15 col-clickable"
                    @click.stop="onOrderIdClick(installation)"
                  >
                    {{ installation.id }}
                  </div>

                  <div
                    class="singleInstallationRow__data blue-color md-layout-item md-xlarge-size-20 md-large-size-20 md-medium-size-20 md-small-size-30 col-clickable"
                    @click.stop="onAdCodeClick(installation)"
                  >
                    {{ installation.spaceDescription }}
                  </div>

                  <div
                    class="singleInstallationRow__data md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-10 md-small-size-30"
                  >
                    {{ installation.materialName }}
                  </div>

                  <div
                    class="singleInstallationRow__data status_name md-layout-item md-xlarge-size-25 md-large-size-25 md-medium-size-25 md-small-size-25"
                  >
                    {{ installation.statusName }}
                  </div>

                  <div
                    class="singleInstallationRow__data special-labels md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-10 mobile-remove"
                  >
                    {{ installation.size }}
                  </div>

                  <div
                    class="singleInstallationRow__data special-labels md-layout-item md-xlarge-size-25 md-large-size-20 md-medium-size-20 mobile-remove"
                  >
                    {{ installation.deposition }}
                  </div>

                  <div
                    class="md-layout-item md-large-size-5 md-medium-size-5 mobile-remove"
                  >
                    <div class="md-layout md-layout-item">
                      <div
                        class="singleInstallationRow__expand-btn expand-btn"
                        @click.stop="goToSeeDetails(installation)"
                      >
                        <md-icon>expand_more</md-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="installation.is_expanded" class="installation-expanded-slot">
              <MaterialPDF
                v-if="
                  expandedContentType === 'pdf' &&
                  currentlyExpandedInstallation === installation
                "
                :pdf="pdf"
              />
              <div
                v-else-if="
                  expandedContentType === 'map' &&
                  currentlyExpandedInstallation === installation
                "
                class="installation-expanded-slot__map"
              >
                <h3 class="installation-expanded-slot__title">
                  Floor location — {{ getAdCodeLabel(installation) }}
                </h3>
                <FloorPlanMapView
                  :key="'map-' + installation.id"
                  :embedded-large="true"
                  v-bind="floorMapPropsFor(installation)"
                />
              </div>
            </div>
          </div>
        </div>
      </transition>

      <md-dialog :md-active.sync="showInstallationModal">
        <div class="md-layout md-alignment-bottom-space-between">
          <div @click="closeModal">
            <md-icon class="md-size-2x">keyboard_backspace</md-icon>
          </div>
          <div @click="closeModal">
            <md-icon class="md-size-2x">close</md-icon>
          </div>
        </div>
        <MaterialPDF :pdf="pdf" />
        <md-button
          class="md-primary md-raised close-modal-button"
          @click.stop="closeModal"
        >
          close
        </md-button>
      </md-dialog>

      <md-snackbar
        md-position="center"
        :md-active.sync="snackbar.show"
        :md-duration="snackbar.duration"
        md-persistent
      >
        <span>{{ snackbar.message }}</span>
        <md-button class="md-primary" @click="undoStatusUpdate">Undo</md-button>
      </md-snackbar>

      <md-snackbar
        md-position="center"
        :md-active.sync="floorMapSnackbar.show"
        :md-duration="floorMapSnackbar.duration"
      >
        <span>{{ floorMapSnackbar.message }}</span>
        <md-button class="md-primary" @click="floorMapSnackbar.show = false"
          >OK</md-button
        >
      </md-snackbar>
    </div>
  </div>
</template>

<script>
import MaterialPDF from "@/components/MaterialDashboard/MaterialPDF.vue";
import FloorPlanMapView from "@/components/Map/FloorPlanMapView.vue";

export default {
  name: "InstallationDashboardTable",
  props: {
    installationsProp: {
      type: Array,
    },
  },

  data: function() {
    return {
      isAllChecked: false,
      loadingSpinner: false,
      selectedInstallationForModal: null,
      showInstallationModal: false,
      snackbar: {
        show: false,
        message: "Last chance to undo the changes?",
        duration: 4000,
      },
      undo: false,
      currentSort: "id",
      currentSortDir: "asc",
      installations: this.installationsProp,
      pdf: "",
      currentlyExpandedInstallation: null,
      /** null | 'pdf' | 'map' — which panel shows under the expanded row */
      expandedContentType: null,
      floorMapSnackbar: {
        show: false,
        message: "",
        duration: 4000,
      },
    };
  },

  components: {
    MaterialPDF,
    FloorPlanMapView,
  },

  mounted() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js",
    );
    document.head.appendChild(recaptchaScript);
  },

  methods: {
    showSnackBar() {
      this.undo = false;
      this.snackbar.show = true;
    },
    undoStatusUpdate() {
      this.undo = true;
      this.snackbar.show = false;
    },
    updateMarkedAsInstalled() {
      this.showSnackBar();
      setTimeout(() => {
        if (this.undo) return;
        for (let i = 0; i < this.installations.length; i++) {
          if (this.installations[i].is_checked) {
            this.installations[i].markInstalled();
          }
        }
      }, 4000);
    },

    updateMarkedAsRemoved() {
      this.showSnackBar();
      setTimeout(() => {
        if (this.undo) return;
        for (let i = 0; i < this.installations.length; i++) {
          if (this.installations[i].is_checked) {
            this.installations[i].markRemoved();
          }
        }
      }, 4000);
    },

    updateMarkedAsArrivedInStaging() {
      this.showSnackBar();
      setTimeout(() => {
        if (this.undo) return;
        for (let i = 0; i < this.installations.length; i++) {
          if (this.installations[i].is_checked) {
            this.installations[i].markArrivedInStaging();
          }
        }
      }, 4000);
    },

    updateMarkedAsGivenToAndMore() {
      this.showSnackBar();
      setTimeout(() => {
        if (this.undo) return;
        for (let i = 0; i < this.installations.length; i++) {
          if (this.installations[i].is_checked) {
            this.installations[i].markGivenToAndMore();
          }
        }
      }, 4000);
    },

    updateMarkedAsDeliveredToSpecificLocation() {
      this.showSnackBar();
      setTimeout(() => {
        if (this.undo) return;
        for (let i = 0; i < this.installations.length; i++) {
          if (this.installations[i].is_checked) {
            this.installations[i].markDeliveredToSpecificLocation();
          }
        }
      }, 4000);
    },

    printTicketApiSegment(installation) {
      const isSponsorship =
        installation.mediaType === "sponsorship" ||
        installation.media_id == 6 ||
        typeof installation.sponsorships_id !== "undefined";
      return isSponsorship ? "sponsorships" : "signage-orders";
    },

    fetchPrintTicket(installation) {
      const mediaType = this.printTicketApiSegment(installation);
      this.$axios
        .get(`/${mediaType}/${installation.id}/print-ticket`)
        .then((res) => {
          this.pdf = res.data;
        })
        .catch((err) => {
          this.$emit("printFailed", err.message);
        });
    },

    /**
     * Print ticket: expand row (or collapse second click). Switch map → print without closing.
     */
    expandOrToggleForPrint(installation) {
      if (
        this.currentlyExpandedInstallation &&
        this.currentlyExpandedInstallation !== installation
      ) {
        this.currentlyExpandedInstallation.is_expanded = false;
      }

      if (
        this.currentlyExpandedInstallation === installation &&
        installation.is_expanded
      ) {
        if (this.expandedContentType === "map") {
          this.expandedContentType = "pdf";
          this.fetchPrintTicket(installation);
          this.$forceUpdate();
          return;
        }
        installation.is_expanded = false;
        this.expandedContentType = null;
        this.currentlyExpandedInstallation = null;
        this.$forceUpdate();
        return;
      }

      installation.is_expanded = true;
      this.currentlyExpandedInstallation = installation;
      this.expandedContentType = "pdf";
      this.fetchPrintTicket(installation);
      this.$forceUpdate();
    },

    goToSeeDetails(installation) {
      this.expandOrToggleForPrint(installation);
    },

    onOrderIdClick(installation) {
      this.openPrintTicketForOrder(installation);
    },

    floorMapPropsFor(installation) {
      const c = this.getFloorMapContext(installation);
      return {
        buildingId: c.buildingId,
        floorId: c.floorId,
        markerX: c.markerX,
        markerY: c.markerY,
        tooltipLine: installation.materialName
          ? `Material: ${installation.materialName}`
          : "",
      };
    },

    /**
     * Floor map: expand row (or collapse second click). Switch print → map without closing.
     */
    expandOrToggleForMap(installation) {
      if (!this.canShowFloorMap(installation)) {
        this.floorMapSnackbar.message =
          "Floor map data is not available for this ad space.";
        this.floorMapSnackbar.show = true;
        return;
      }

      if (
        this.currentlyExpandedInstallation &&
        this.currentlyExpandedInstallation !== installation
      ) {
        this.currentlyExpandedInstallation.is_expanded = false;
      }

      if (
        this.currentlyExpandedInstallation === installation &&
        installation.is_expanded
      ) {
        if (this.expandedContentType === "pdf") {
          this.expandedContentType = "map";
          this.$forceUpdate();
          return;
        }
        installation.is_expanded = false;
        this.expandedContentType = null;
        this.currentlyExpandedInstallation = null;
        this.$forceUpdate();
        return;
      }

      installation.is_expanded = true;
      this.currentlyExpandedInstallation = installation;
      this.expandedContentType = "map";
      this.$forceUpdate();
    },

    onAdCodeClick(installation) {
      this.expandOrToggleForMap(installation);
    },

    getAdCodeLabel(installation) {
      return (
        installation.spaceDescription || installation.locationName || "Ad space"
      );
    },

    getFloorMapContext(installation) {
      const x =
        installation.floorMapX ??
        installation.x_coordinate ??
        installation.x ??
        installation.map_x;
      const y =
        installation.floorMapY ??
        installation.y_coordinate ??
        installation.y ??
        installation.map_y;
      const bid = installation.building_id;
      const fid =
        installation.adspaces_floor !== undefined &&
        installation.adspaces_floor !== null &&
        installation.adspaces_floor !== ""
          ? installation.adspaces_floor
          : installation.floor_id;

      const toNullableNum = (v) => {
        if (v === null || v === undefined || v === "") {
          return null;
        }
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      };

      return {
        markerX: toNullableNum(x),
        markerY: toNullableNum(y),
        buildingId:
          bid === null || bid === undefined || bid === "" ? null : bid,
        floorId: fid === null || fid === undefined || fid === "" ? null : fid,
      };
    },

    canShowFloorMap(installation) {
      const c = this.getFloorMapContext(installation);
      return (
        c.buildingId != null &&
        c.floorId != null &&
        c.markerX != null &&
        c.markerY != null
      );
    },

    openPrintTicketForOrder(installation) {
      if (window.screen.availWidth < 900) {
        this.selectedInstallationForModal = installation;
        this.fetchPrintTicket(installation);
        this.showInstallationModal = true;
        document.body.style.overflow = "hidden";
      } else {
        this.expandOrToggleForPrint(installation);
      }
    },

    orderResults(sortColumn) {
      if (sortColumn === this.currentSort) {
        this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      } else {
        this.currentSortDir = "asc";
      }
      this.currentSort = sortColumn;
    },

    closeModal() {
      this.showInstallationModal = false;
      document.body.style.overflow = "";
    },
  },

  watch: {
    isAllChecked(value) {
      for (let i = 0; i < this.installations.length; i++) {
        this.installations[i].is_checked = value;
      }
      this.$forceUpdate();
    },

    installationsProp(value) {
      this.installations = value;
    },
  },

  computed: {
    sortedInstallations() {
      const filtered = (Array.isArray(this.installationsProp)
        ? this.installationsProp
        : []
      )
        .filter((inst) => inst && typeof inst === "object")
        .filter((inst) => {
          const isSponsorship =
            inst.mediaType === "sponsorship" ||
            inst.media_id === 6 ||
            typeof inst.sponsorships_id !== "undefined";
          const sponsorshipStatus =
            typeof inst.sponsorship_status !== "undefined"
              ? inst.sponsorship_status
              : typeof inst.sponsorship_status_id !== "undefined"
              ? inst.sponsorship_status_id
              : inst.status;

          return !(isSponsorship && Number(sponsorshipStatus) === 49);
        });

      const key = this.currentSort;
      const dir = this.currentSortDir === "desc" ? -1 : 1;

      const compare = (a, b) => {
        if (key === "id") {
          const na = Number(a.id);
          const nb = Number(b.id);
          const va = Number.isFinite(na) ? na : 0;
          const vb = Number.isFinite(nb) ? nb : 0;
          if (va !== vb) {
            return (va - vb) * dir;
          }
          return 0;
        }

        const rawA = a[key];
        const rawB = b[key];
        const sa =
          rawA === null || rawA === undefined ? "" : String(rawA);
        const sb =
          rawB === null || rawB === undefined ? "" : String(rawB);
        return sa.localeCompare(sb, undefined, {
          numeric: true,
          sensitivity: "base",
        }) * dir;
      };

      return filtered.slice().sort(compare);
    },
  },
};
</script>

<style lang="scss" scoped>
.installation-table {
  margin-top: 40px;
  height: 98vh;
  overflow: auto;
  border: 1px solid #b90b0b;
  position: relative;

  @include respond(small) {
    -webkit-overflow-scrolling: touch;
  }
}

.sticky_header {
  position: sticky;
  top: 0;
  /* Ensure z-index is high so content scrolls BEHIND it */
  z-index: 100;

  /* Box shadow for visual separation */
  box-shadow: 0 -6px 10px 5px rgba(0, 0, 0, 0.5);

  /* CRITICAL FIX: Ensure background is white and opaque */
  background-color: white;

  /* Ensure it stretches to fit content width */
  width: max-content;
  min-width: 100%;
}

.singleInstallationRow__header {
  text-align: center;
  background-color: white; /* Double check background here */
  font-weight: bold;
  color: #222222;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 2px solid gray;
  width: 100%;
  flex-wrap: nowrap;

  @include respond(small) {
    font-size: 0.8rem;
    min-width: 742px;
    width: max-content;
    border-bottom: none;
    .md-layout-item.md-small-size-15 {
      text-align: left !important;
      padding-left: 0 !important;
      margin-left: 0 !important;
      justify-content: flex-start !important;
      display: flex !important;
    }
  }

  h2 {
    cursor: pointer;
    white-space: nowrap;
  }
}

.singleInstallationRow {
  text-align: center;
  padding-top: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #7d7d7d;
  width: 100%;
  min-width: 0;
  flex-wrap: nowrap;

  @include respond(small) {
    width: max-content;
    min-width: 742px;
    cursor: pointer;
    border-bottom: none;
  }
}

.blue-color {
  color: #313b8e;
  font-weight: 500;
}

.singleInstallationRow__data {
  font-size: 1.4rem;
  white-space: normal;
  word-break: break-word;

  @include respond(small) {
    font-size: 1rem;
    line-height: 1.2;
    white-space: normal;
  }
}

// On mobile, push ART ID to far left
@include respond(small) {
  .singleInstallationRow__data.md-small-size-15 {
    text-align: left !important;
    margin-left: 0 !important;
    padding-left: 0 !important;
    justify-content: flex-start !important;
    display: flex !important;
    width: 100%;
  }
}

.col-clickable {
  cursor: pointer;
}

.col-clickable:hover {
  text-decoration: underline;
}

.singleInstallationRow__header .md-layout,
.singleInstallationRow .md-raised.md-layout {
  flex-wrap: nowrap;
}

.check-btn {
  padding-left: 4rem;
  padding-top: 0.8rem;

  @include respond(small) {
    padding-left: 1.3rem;
    padding-top: 0.4rem;
  }

  .input-check-box {
    transform: scale(2.1);

    @include respond(small) {
      transform: scale(1.6);
    }
  }
}

.mark-arrived-btn,
.mark-delivered-to-location-btn,
.mark-given-to-andmore-btn,
.mark-removed-btn,
.mark-installed-btn {
  max-width: 280px;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  padding: 10px 12px !important;
  font-size: 1.1rem;
  line-height: 1.2;
  overflow-wrap: break-word;
  height: auto;
  flex: 1;
  min-width: 140px;
  text-align: left;
  justify-content: flex-start;
}

.mark-given-to-andmore-btn,
.mark-delivered-to-location-btn {
  max-width: 120px;
}

@include respond(small) {
  .mark-arrived-btn,
  .mark-delivered-to-location-btn,
  .mark-given-to-andmore-btn,
  .mark-removed-btn,
  .mark-installed-btn {
    max-width: 100%;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    padding: 10px 12px !important;
    font-size: 1.3rem;
    line-height: 1.2;
    overflow-wrap: break-word;
    height: auto;
    flex: 1;
    min-width: 100px;
    text-align: left;
    justify-content: flex-start;
  }

  .mark-given-to-andmore-btn,
  .mark-delivered-to-location-btn {
    max-width: 110px;
  }
}

@media (min-width: 959px) {
  .mark-installed-btn,
  .mark-removed-btn {
    display: flex !important;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: auto;
    text-align: left;
    position: relative;
    white-space: nowrap;
  }
  .mark-installed-btn .mark-installed-icon,
  .mark-removed-btn .mark-removed-icon {
    margin-left: 8px !important;
    margin-right: 0 !important;
    position: static;
    vertical-align: middle;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
  }
}

.mark-arrived-icon {
  margin-left: auto !important;
  margin-right: 0 !important;
}

.mark-delivered-to-location-icon {
  margin-left: auto !important;
  margin-right: 0 !important;
}

.mark-given-to-andmore-icon {
  margin-left: auto !important;
  margin-right: 0 !important;
}

.singleInstallationRow__btns {
  border-top: 1px solid gray;
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 2px solid gray;
  background-color: white; /* Ensure background is opaque */
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  .md-layout-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 0;
    flex-wrap: nowrap;
    gap: 8px;
  }

  @include respond(small) {
    gap: 6px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    .md-layout-item {
      gap: 6px;
    }
  }
}

.main-icons {
  margin-left: 8px;
  font-size: 20px !important;

  @include respond(small) {
    margin-left: 6px;
    font-size: 18px !important;
  }
}

.expand-btn {
  cursor: pointer;
}

.expanded {
  background-color: #f1f1f1;
}

.installation-expanded-slot {
  padding: 16px 16px 20px;
  background-color: #f1f1f1;
  border-bottom: 2px solid #7d7d7d;
}

.installation-expanded-slot__title {
  margin: 0 0 12px;
  font-size: 1.15rem;
  font-weight: 600;
  color: #222;
}

.installation-expanded-slot__map {
  max-width: 100%;
  width: 100%;
  min-height: 72vh;
}

.icons {
  cursor: pointer;
  margin-left: 6px;
  font-size: 18px !important;

  @include respond(small) {
    font-size: 16px !important;
    margin-left: 4px;
  }
}

.status_name {
  @include respond(small) {
    text-align: center;
  }
}

/* Small screens (below 768px) */
@include respond(small) {
  .singleInstallationRow__btns {
    flex-wrap: wrap;
    padding: 8px;
    gap: 6px;
  }

  .mark-installed-btn,
  .mark-removed-btn,
  .mark-arrived-btn,
  .mark-given-to-andmore-btn,
  .mark-delivered-to-location-btn {
    flex: 1 1 45%;
    margin: 2px 0;
    font-size: 1.33rem;
    padding: 8px 12px;
  }

  .mark-delivered-to-location-btn {
    flex: 1 1 100%;
  }

  .main-icons {
    font-size: 14px !important;
    margin-left: 4px !important;
  }

  .check-btn .input-check-box {
    transform: scale(1.2);
  }
}

.close-modal-button {
  margin-bottom: 20px;
}
</style>
